import { useTracking } from '@components/hooks';
import styles from '@components/components/HeatInstallationForm/components/ActionFooter/ActionFooter.module.scss';
import React from 'react';
import { Button } from '@wienenergiegithub/ui-next';
import { FormSubmit } from '@ariakit/react';

const ActionFooter = ({
  store,
  step,
  stepName,
  prev,
  nextText,
  isGeneralRecommender,
  handleSkipStep,
  handleGeneralPrevStep,
  isFinalStep,
  setNextValidStep,
}) => {
  const track = useTracking();

  const handleNextStep = () => {
    track({
      event: 'fernwaerme-nachinstallieren_steps',
      eventCategory: 'fernwaerme-nachinstallieren_steps',
      eventAction: `step${step}`,
      eventName: stepName,
    });
    setNextValidStep();
  };

  const installationSteps =
    stepName === 'ergebnis' ||
    stepName === 'formular' ||
    stepName === 'kostenkalkulation';

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        {isFinalStep ? (
          <FormSubmit
            data-purpose="heat-installation-form-btn-submit"
            id="next"
            render={
              <Button className={styles.action} isElevated>
                {nextText}
              </Button>
            }
            store={store}
          />
        ) : (
          <Button
            className={styles.action}
            data-purpose="heat-installation-form-btn-submit"
            disabled={store.useValue('isOwner') !== 'Ja'}
            id="next"
            isElevated
            onClick={handleNextStep}
          >
            {nextText}
          </Button>
        )}

        {isGeneralRecommender && (
          <Button
            className={styles.link}
            onClick={handleSkipStep}
            variant="link"
          >
            {stepName === 'formular' || stepName === 'ergebnis'
              ? 'Beratung überspringen'
              : 'Fernwärme überspringen'}
          </Button>
        )}
      </div>
      {(prev || handleGeneralPrevStep) && (
        <Button
          className={styles.action}
          data-purpose="heat-installation-form-btn-back"
          id="prev"
          onClick={
            isGeneralRecommender && !installationSteps
              ? handleGeneralPrevStep
              : prev
          }
          variant="outline"
        >
          Zurück
        </Button>
      )}
    </div>
  );
};

export default ActionFooter;
